module.exports = __webpack_public_path__ + "img/verdico.c504c683.svg";